import React, { forwardRef } from 'react';
import { FormSectionTitle } from '../atoms/FormSectionTitle';
import { InputField } from '../atoms/InputField';
import { RequiredLabel } from './RequiredLabel';
type LabeledInputFieldProps = {
  title: string;
  inline?: boolean;
  className?: string;
  ariaLabel?: string;
  required?: boolean;
} & React.InputHTMLAttributes<HTMLInputElement>;

export const LabeledInputField = forwardRef<HTMLInputElement, LabeledInputFieldProps>(
  (_props, ref) => {
    const { inline, title, className, ariaLabel, required, ...props } = _props;
    return (
      <div className={inline ? 'inline-block' : 'block'}>
        <div className="flex items-center gap-2">
          <FormSectionTitle text={title} htmlFor={props.id} />
          {required && <RequiredLabel id={props.id} />}
        </div>
        <InputField className={className} aria-label={ariaLabel} {...props} ref={ref} />
      </div>
    );
  }
);
LabeledInputField.displayName = 'LabeledInputField';
